<template>
    <div>
        <b-modal :id="modalId"
            modal-class="modal-serial"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <div id="redeem_icon_close" @click="close()">
                        <img src="../../../../assets/icon/otp_icon_close@2x.png">
                    </div>
                    <SerialHeader
                        :serialModel="serialModel" />
                </div>
                <div class="modal-base-body">
                    <Serial
                        :lbl="lbl"
                        :serialModel="serialModel"
                        :controller="controller" />
                    <div id="redeem_on_date">
                        {{getRedeemMessage()}}
                    </div>
                </div>
                <div class="modal-base-footer">
                    <SerialTimer
                        :lbl="lbl.serial"
                        :serialModel="serialModel"
                        :controller="controller" />
                    <SerialFooter />                    
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Moment from 'moment';
//helper
import CacheHelper from "@/helper/CacheHelper.js";
import Locale from '@/helper/locale/locale.js';
import Util from '@/helper/Utility.js';
//component
import Serial from './Component/Serial.vue';
import SerialFooter from './Component/SerialFooter.vue';
import SerialHeader from './Component/SerialHeader.vue';
import SerialTimer from './Component/SerialTimer.vue';

export default {
    name: 'SerialModal',
    components: {
        Serial,
        SerialFooter,
        SerialHeader,
        SerialTimer
    },
    props: {
        controller: Object,
        modalId: String
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),

            serialModel: {},
            tag: null,

            busModal: null
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        //event
        close: function () {
            var cache = new CacheHelper('session');

            if(cache.getCache('FromHistory')){
                cache.removeCache('FromHistory')
            }else if(cache.getCache('isFromBDM')){
                cache.removeCache('isFromBDM');
                this.$router.push('/');
            }else{
                this.$router.back();
            }

            this.hide();
        },
        getRedeemMessage: function () {
            var expireDate = this.serialModel.redeemTimestamp;
            var result = Moment.unix(expireDate).utc();
            var year = result.format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;
                year = year.toString().substring(2, 4);

            var day = result.format('DD');
            var month = result.format('MM');
            var date = `${day}/${month}/${year} ${result.format('HH:mm')} ${this.lbl.date.minutes_short}`;

            return Util.stringFormat(this.lbl.serial.redeem_on, date);
        },
        //modal
        show: function (config) {
            this.serialModel = config.serialModel;
            this.tag = config.tag;

            this.$bvModal.show(this.modalId);
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

#redeem_on_date {
    font-size: 1.25rem;
    line-height: 1;
    text-align: center;
    color: $bright-gray;
}
#redeem_icon_close{
    position: absolute;
    right: 20px;
    top: 20px;

    img{
        width: 15px;
    }
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/modal.scss";
.modal-serial {
    .modal-body{
        padding: 1rem 1rem 0;
    }

    .modal-dialog {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        margin: auto;
    }

    .modal-content{
        border: none;
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    
    .modal-base-footer{
        @extend %display-flex;
        padding-top: 30px;
    }
    .modal-base-footer>div{
        flex: 0 0 calc(100% / 2);
        width: calc(100% / 2);
    }
    #serial_timer{
        text-align: left;
    }
}
</style>
